import { AxiosResponse } from 'axios';
export class HttpServerError extends Error {
    constructor(public response: AxiosResponse) {
        super();
    }
}
